module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step.type == 'heading') ? _c('div', {
    staticClass: "heading-label"
  }, [_vm._v(_vm._s(_vm.step.title))]) : _vm._e(), _vm._v(" "), (_vm.step.type == 'task') ? _c('div', {
    staticClass: "new-item-label"
  }, [_vm._v("\n        " + _vm._s(_vm.step.title) + "\n        "), (_vm.step.description && !_vm.step.expanded) ? _c('div', {
    staticClass: "description-text"
  }, [_vm._v(_vm._s(_vm.step.description))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step.type == 'text') ? _c('v-text-field', {
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "value": _vm.step.value,
      "label": _vm.step.title,
      "hide-details": ""
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.type == 'true-false/switch') ? _c('v-switch', {
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "color": "blue",
      "value": _vm.step.value,
      "label": _vm.step.title,
      "hide-details": ""
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.type == 'true-false/checkbox') ? _c('v-checkbox', {
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "color": "blue",
      "value": _vm.step.value,
      "label": _vm.step.title,
      "hide-details": ""
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.type == 'file/upload') ? _c('FileUpload', {
    attrs: {
      "step": _vm.step
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d5239fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/StepSelector.vue
// module id = 2475
// module chunks = 1